import { FormControl, InputLabel, MenuItem } from '@mui/material';
import { CustomSelect } from './DropdownSelect.styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import { palette, rem } from '@innovyze/stylovyze/lib/utils/styles';
export const DropdownSelect = ({ className, dataCy, currentSelection, title, options, onChange, inlineStyle, }) => {
    return (React.createElement(FormControl, { variant: "standard", style: inlineStyle, className: className, "data-cy": dataCy },
        React.createElement(InputLabel, { style: {
                color: palette.secondary.main,
            } }, title),
        React.createElement(CustomSelect, { style: {
                color: palette.secondary.dark,
                height: rem(16),
                marginTop: rem(22),
            }, value: currentSelection, IconComponent: ExpandMoreIcon, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: onChange }, options.map((el) => {
            const value = typeof el === 'string' ? el : el.value;
            const key = typeof el === 'string' ? el : el.key;
            const label = typeof el !== 'string' && el.label ? el.label : value;
            return (React.createElement(MenuItem, { key: key, value: key }, label));
        }))));
};
export default DropdownSelect;
